// 将DQ/CA合并显示
// console.log(simplifySignalNames(['DQ0', 'DQ1', 'DQ2', 'DQ3', 'CA0', 'CA1', 'DM0B']));
// 输出: "DQ0~3, CA0~1, DM0B"

function simplifySignalNames(signals) {
  const signalGroups = {};
  signals.forEach(signal => {
    const match = signal.match(/^([A-Za-z]+)(\d+)([A-Za-z]*)$/);
    if (match) {
      const prefix = match[1];
      const number = parseInt(match[2]);
      const suffix = match[3];
      const groupKey = `${prefix}|${suffix}`;

      if (!signalGroups[groupKey]) {
        signalGroups[groupKey] = {
          prefix: prefix,
          suffix: suffix,
          numbers: []
        };
      }
      signalGroups[groupKey].numbers.push(number);
    } else {
      if (!signalGroups.others) signalGroups.others = [];
      signalGroups.others.push(signal);
    }
  });

  const result = [];

  for (const groupKey in signalGroups) {
    if (groupKey === 'others') {
      result.push(...signalGroups.others);
      continue;
    }

    const group = signalGroups[groupKey];
    group.numbers.sort((a, b) => a - b);

    const ranges = [];
    let start = group.numbers[0];
    let prev = start;

    for (let i = 1; i < group.numbers.length; i++) {
      if (group.numbers[i] === prev + 1) {
        prev = group.numbers[i];
      } else {
        ranges.push(start === prev ? start : `${start}~${prev}`);
        start = group.numbers[i];
        prev = start;
      }
    }
    ranges.push(start === prev ? start : `${start}~${prev}`);

    const abbreviated = ranges.map(range =>
      `${group.prefix}${range}${group.suffix}`
    ).join(', ');

    result.push(abbreviated);
  }
  return result.join(', ');
}

export {
  simplifySignalNames
}